import { Link } from "react-router-dom";

const ErrorPage = () => {
    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f8d7da",
            color: "#721c24",
            fontSize: "24px",
            fontWeight: "bold",
            textAlign: "center",
        }}>
            ❌ Üzr istəyirik, bir problem baş verdi. Zəhmət olmasa yenidən cəhd edin.
            <Link 
                to="/" 
                style={{
                    marginTop: "20px",
                    textDecoration: "none",
                    color: "#fff",
                    backgroundColor: "#ff6010",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    fontSize: "18px",
                    fontWeight: "bold"
                }}
            >
                🏠 Ana səhifəyə geri dönün
            </Link>
        </div>
    );
};

export default ErrorPage;